<mat-form-field *ngIf="control" class="acf-full-width" [appearance]="appearance">
    <mat-label>{{label | translate}}</mat-label>
    <!-- <mat-label>{{label | translate}}</mat-label> -->
    <ng-container *ngIf="control">
        <input (click)="filter()" type="text" aria-label="range" placeholder="{{placeholder | translate}}" matInput [formControl]="control" [matAutocomplete]="range" [required]="required" [disabled]="field_disabled">
    </ng-container>
    <!-- <ng-container *ngIf="controlName">
        <input (click)="filter()" type="text" aria-label="range" placeholder="{{placeholder | translate}}" matInput [formControlName]="controlName" [matAutocomplete]="range" [required]="required">
    </ng-container> -->
    <mat-autocomplete class="relative" autoActiveFirstOption #range="matAutocomplete" [displayWith]="displayWith">
        <ng-container *ngIf="this.isLoading">
            <mat-option>
                <mat-spinner style="margin: auto;" [diameter]="40"></mat-spinner>
            </mat-option>
        </ng-container>
        <ng-container *ngIf="!this.isLoading">
            <mat-paginator *ngIf="this.local_pagination && (filteredOptions.length > this.local_pagination.limit)" [length]="filteredOptions.length" [pageSize]="this.local_pagination.limit" [hidePageSize]="true" [pageIndex]="this.local_pagination.skip / this.local_pagination.limit" (page)="onPage($event)"></mat-paginator>
            <ng-container *ngIf="this.groupBy; else noGroup">
                <mat-optgroup *ngFor="let group of groupedOptions; trackBy: trackByItems" [label]="group.slug">
                    <mat-option *ngFor="let option of group.values; trackBy: trackByItems" [value]="value(option)">
                        <p class="flex items-center gap-2">
                            <span>{{ getLabel(option) }}</span>
                            <span *ngIf="secondaryDisplayKey" class="text-xs text-gray-500">{{ getSecondaryLabel(option) }} </span>
                        </p>
                    </mat-option>
                </mat-optgroup>
            </ng-container>
            <ng-template #noGroup>
                <mat-option *ngFor="let option of paginatedOptions; trackBy: trackByItems" [value]="value(option)">
                    <p class="flex items-center gap-2">
                        <span>{{ getLabel(option) }}</span>
                        <span *ngIf="secondaryDisplayKey" class="text-xs text-gray-500">{{ getSecondaryLabel(option) }} </span>
                    </p>
                </mat-option>
            </ng-template>
        </ng-container>
    </mat-autocomplete>
    <mat-error> {{error | translate}} </mat-error>
</mat-form-field>